// remember to update confluence page after modifying this file
// https://dop-orange.atlassian.net/wiki/spaces/WUWA/pages/1827602540/Nju+Tagging+DataLayer

interface IPushAddToCartEventGA4Props {
  productId: string;
  productPrice: number;
  subscriptionCategory: string;
  numberCount: number;
}

export function pushAddToCartEventGA4({
  productId,
  productPrice,
  numberCount,
  subscriptionCategory,
}: IPushAddToCartEventGA4Props) {
  if ("dataLayer" in window) {
    window.dataLayer.push({
      event: "add_to_cart_GA4",
      ecommerce: {
        currency: "PLN",
        value: productPrice * numberCount,
        items: [
          {
            item_id: productId,
            item_name: "Nju subskrypcja",
            affiliation: "",
            coupon: "",
            discount: 0,
            index: 0,
            item_brand: "Nju",
            item_category: "Subskrypcja",
            item_category2: subscriptionCategory,
            item_category3: "Podstawowy/Subskrypcja",
            item_category4: `Subskrypcja/${subscriptionCategory}`,
            item_variant: String(numberCount),
            item_list_name: "",
            location_id: "",
            price: productPrice,
            quantity: 1,
          },
        ],
      },
    });
  }
}
